/* eslint-disable no-console */

import axios from "axios";
import * as Sentry from "@sentry/vue";

const URL = "";
const services = /(newsitems|filters|eventreports)/;

const remoteSecure = axios.create({
  // append residref to this url
  // add /thumb/ for thumbnail version
  baseURL: "https://cr.dpa-connect.de/v1/media/"
});

// TODO: Change to await
export const fetchThumbnail = async (authJWT, residref) => {
  try {
    // removed Accept: "image/jpeg, application/json"
    // as it was easier to use as a string
    const thumbnail = await remoteSecure.get(`${residref}`, {
      headers: {
        ...(authJWT
          ? {
              Authorization: `Bearer ${authJWT}`
            }
          : {})
      }
    });
    return thumbnail;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const call = method => async ({
  url,
  payload,
  authJWT,
  version = "/api/v1"
}) => {
  const transactionID = Math.random()
    .toString(36)
    .substring(2, 9);

  Sentry.configureScope(scope => {
    scope.setTag("transaction_id", transactionID);
  });

  try {
    const [path, query] = url.split("?");
    const service =
      path.match(services) !== null ? path.match(services)[0] : "";
    const formattedPath = `${URL}/${path.replace(
      services,
      `${service}${version}`
    )}`;

    const callParams = [
      `${formattedPath}${query ? `?${query}` : ""}`,
      ...(payload ? [payload] : []),
      {
        headers: {
          ...(authJWT
            ? {
                Authorization: `Bearer ${authJWT}`
              }
            : {}),
          "X-Transaction-ID": transactionID
        }
      }
    ];
    const { data } = await (axios[method](...callParams) || {});
    return data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export default {
  get: call("get"),
  post: call("post"),
  put: call("put"),
  patch: call("patch"),
  delete: call("delete")
};
